import {Injectable} from '@angular/core';
import {ParentTableService} from './parent-table.service';
import { ODataEntitySetService, ODataServiceFactory } from 'angular-odata';
import {exportable$} from './decorators/exportable';
import {Scope} from '../../models/scope';
import {SettingsService} from '../settings/settings.service';
import {map} from 'rxjs/operators';
import {ODataResponseMapper} from './mappers/odata-response-mapper';
import {SQDataConfiguration} from './configuration/OData-configuration';
import {HelperFunctions} from './configuration/helper-functions';

@Injectable({
  providedIn: 'root'
})
export class NominationScopeService extends ParentTableService {
  private odata: ODataEntitySetService<Scope>;
  private readonly config: SQDataConfiguration;
  private _userProfile = null;
  @exportable$ nominationscope: any;
  subscription = null;

  constructor(private odataFactory: ODataServiceFactory, private settingsService: SettingsService) {
    super('NominationScopeService');
    this.odata = this.odataFactory.entitySet<Scope>('Overview(0)/WorkloadNomination');
    this.config = new SQDataConfiguration();
    this.subscription = this.settingsService.profileData.subscribe(profile => {
      if (profile) {
        this._userProfile = profile;
      }
    });
  }

  getData(pageIndex, count, sortModel, filterModel) {
    const orders = [];
    sortModel.forEach(x => {
      orders.push(x.colId.replace(/\./g, '/') + ' ' + x.sort);
    });

    let filter = '';
    if (localStorage.getItem('showRejectedNominations') === 'true') {
      filter += 'IsNominated eq false';
    } else {
      filter += 'IsNominated ne false';
    }
    filter = HelperFunctions.addOdataFilters(filter, filterModel);

    const query = this.odata.entities().query(q => {
      q.top(count);
      q.skip(count * pageIndex);
      if (orders.length > 0) q.orderBy(orders);
      if (filter?.length) q.filter(filter);
      return q;
    });

    this.nominationscope = query;
    return this.nominationscope.fetch({ withCount: true }).pipe(map((r: any) => ODataResponseMapper.mapResponse(r)));
  }

}
